
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: 'HelpPage',
}) 
export default class HelpPage extends Vue {
}
